var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import crypto from 'crypto';
import { BroadcastChannel } from 'broadcast-channel';
var FuncBuilder = function (channel) {
    var functions = channel.callbacks;
    return {
        addFunction: function (cb) {
            if (Array.isArray(cb)) {
                cb.forEach(function (handler) {
                    if (!channel.callbacks.find(function (callback) { return callback === handler; })) {
                        functions.push(handler);
                    }
                });
            }
            else if (!channel.callbacks.find(function (callback) { return callback === cb; })) {
                functions.push(cb);
            }
            channel.callbacks = functions;
        },
    };
};
export var Broker = function () {
    var _a;
    var eventsMap = {};
    var globalData = {};
    var mounted = false;
    var brokerId = typeof window !== 'undefined' && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : (_a = crypto.randomUUID) === null || _a === void 0 ? void 0 : _a.call(crypto);
    var handleMessage = function (channel) { return function (args) {
        if (args.brokerId === brokerId) {
            channel.callbacks.forEach(function (cb) {
                return cb(__assign(__assign({}, args), { globalData: globalData }));
            });
        }
    }; };
    return {
        setMounted: function () {
            mounted = true;
        },
        setGlobalData: function (data) {
            globalData = data;
        },
        close: function (name, cb) {
            var channel = eventsMap["subs-".concat(name)];
            if (!channel)
                return;
            if (channel.callbacks.length < 2) {
                eventsMap["subs-".concat(name)].close();
                eventsMap["subs-".concat(name)] = undefined;
            }
            channel.callbacks = channel.callbacks.filter(function (fn) { return fn !== cb; });
        },
        publish: function (name, state) {
            var _a, _b;
            var channel = eventsMap["post-".concat(name)];
            if (!channel) {
                channel = new BroadcastChannel(name);
            }
            var eventId = (_b = (_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID) === null || _b === void 0 ? void 0 : _b.call(_a);
            channel.postMessage(__assign(__assign({}, state), { eventId: eventId, brokerId: brokerId }));
            eventsMap["post-".concat(name)] = channel;
        },
        subscribe: function (name, cb) {
            var channel = eventsMap["subs-".concat(name)];
            if (!channel) {
                channel = new BroadcastChannel(name);
                channel.callbacks = [];
            }
            var funcBuilder = FuncBuilder(channel);
            funcBuilder.addFunction(cb);
            channel.onmessage = handleMessage(channel);
            eventsMap["subs-".concat(name)] = channel;
        },
        subscribeAll: function (events) {
            // do not mount twice
            if (mounted)
                return;
            Object.entries(events).forEach(function (_a) {
                var name = _a[0], cb = _a[1];
                var channel = eventsMap["subs-all-".concat(name)];
                if (!channel) {
                    channel = new BroadcastChannel(name);
                    channel.callbacks = [];
                }
                var funcBuilder = FuncBuilder(channel);
                funcBuilder.addFunction(cb);
                channel.onmessage = handleMessage(channel);
                eventsMap["subs-all-".concat(name)] = channel;
            });
        },
    };
};
